import { render, staticRenderFns } from "./MenuApp.vue?vue&type=template&id=4d233954&scoped=true&"
import script from "./MenuApp.ts?vue&type=script&lang=ts&"
export * from "./MenuApp.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d233954",
  null
  
)

export default component.exports
import {QItem,QItemSection,QIcon,QItemLabel,QBadge,QSeparator,Ripple} from 'quasar'
component.options.components = Object.assign({QItem,QItemSection,QIcon,QItemLabel,QBadge,QSeparator}, component.options.components || {})
component.options.directives = Object.assign({Ripple}, component.options.directives || {})
